import { ILookupValue } from '../lookup-value';
import { IAddress } from './address';
import { IConnectedService } from './connected-service';
import { ICustomerContact } from './customer-contact';
import { ICustomerLink } from './customer-link';
import { ICustomerExternalBillingSettings } from './customer-quickbook-settings';

export interface ICustomer {
  id: number;
  name: string;
  address?: IAddress;
  uniqueId: string;
  snapshotsEnabled: boolean;
  snapshotsBucket?: string;
  snapshotsBucketDownload?: string;
  enabled: boolean;
  websiteUrl?: string;
  industrySector?: ILookupValue;
  imageId?: number;
  city?: ILookupValue;
  nexParkInstance?: ILookupValue;
  nexParkInstanceId?: number;
  connectedServices: IConnectedService[];
  comment?: string;
  updatedAt?: Date;
  updatedBy?: string;
  createdAt: Date;
  createdBy?: string;
  customerContacts: ICustomerContact[];
  customerLinks: ICustomerLink[];
  vaultDirectory?: string;
  ticketId?: string;
  nexParkBillingSettings?: ICustomerExternalBillingSettings;
  nexResponseBillingSettings?: ICustomerExternalBillingSettings;
  nexResponseRegion?: ILookupValue;
  nexResponseRegionId?: number;
}

export function newCustomer() {
  return {
    id: 0,
    name: '',
    uniqueId: '',
    snapshotsEnabled: false,
    enabled: false,
    connectedServices: [],
    customerContacts: [],
    customerLinks: [],
    createdAt: new Date(),
  } as ICustomer;
}
